import { call, put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import { normalize } from 'normalizr';
import * as CatalogApi from 'catalog/api';
import * as Api from 'catalog/api/pages';
import * as UserApi from 'user/api';
import * as Schema from 'catalog/api/schema';
import { replace } from 'react-router-redux';
import { actions as toastrActions } from 'react-redux-toastr';
import { displayJsonError } from 'utils/errors';
import { getPendingPageById } from 'catalog/reducers/pages';
import { getPendingContents } from 'catalog/reducers/contents';
import {
  SAVE_PAGE_SUBMIT,
  SAVE_PAGE_SUCCESS,
  SAVE_PAGE_FAILURE,
  FETCH_PAGES,
  FETCH_PAGES_SUCCESS,
  FETCH_PAGES_FAILURE,
  UPDATE_PAGE,
  UPDATE_PAGE_SUCCESS,
  UPDATE_PAGE_FAILURE,
  ARCHIVE_PAGE,
  UNARCHIVE_PAGE,
} from 'catalog/actions/pages';
import { DEPLOY_SUCCESS } from 'catalog/actions/deployments';

function* fetchPages() {
  try {
    const [settings, roles, templates, platforms, pages] = yield [
      call(CatalogApi.fetchSettings),
      call(UserApi.fetchRoles),
      call(CatalogApi.fetchTemplates),
      call(CatalogApi.fetchPlatforms),
      call(Api.fetch),
    ];

    yield put({
      type: FETCH_PAGES_SUCCESS,
      settings,
      roles,
      templates,
      platforms,
      response: normalize(pages, Schema.pages),
    });
  } catch (error) {
    yield put({
      type: FETCH_PAGES_FAILURE,
      error,
    });
  }
}

function* savePage({ payload }) {
  try {
    const response = yield call(Api.save, payload);

    yield put({
      type: SAVE_PAGE_SUCCESS,
      response: normalize(response, Schema.page),
      payload: response,
    });

    // Redirecting if sepcified
    if (payload.redirectOnCreate) {
      yield put(replace(`/pages/${response.id}`));
    }
  } catch (error) {
    yield put({
      type: SAVE_PAGE_FAILURE,
      payload: {
        _error: displayJsonError(error),
      },
    });
  }
}

function* updatePage({ page }) {
  try {
    const pendingPage = yield select(getPendingPageById, page.id);
    const pendingContents = yield select(getPendingContents, page.id);

    const response = yield call(Api.update, pendingPage, pendingContents);

    yield put({
      type: UPDATE_PAGE_SUCCESS,
      response: normalize(response, Schema.page),
    });
  } catch (error) {
    yield put({
      type: UPDATE_PAGE_FAILURE,
      error,
    });

    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erreur',
        message: 'Une erreur est survenue pendant la sauvegarde de la page',
        options: {
          timeOut: 3000,
          showCloseButton: true,
        },
      })
    );
  }
}

function* archivePage({ page }) {
  yield call(Api.archive, page.id);

  // Relaunch fetching
  yield put({
    type: FETCH_PAGES,
  });
}

function* unarchivePage({ page }) {
  yield call(Api.unarchive, page.id);

  // Relaunch fetching
  yield put({
    type: FETCH_PAGES,
  });
}

export default function* root() {
  yield [
    takeLatest(FETCH_PAGES, fetchPages),
    takeEvery(DEPLOY_SUCCESS, fetchPages), // Fetch pages on deploy
    takeLatest(SAVE_PAGE_SUBMIT, savePage),
    takeEvery(UPDATE_PAGE, updatePage),
    takeEvery(ARCHIVE_PAGE, archivePage),
    takeEvery(UNARCHIVE_PAGE, unarchivePage),
  ];
}



// WEBPACK FOOTER //
// ./src/modules/catalog/sagas/pages.js